import React from 'react';
import { LinkProps } from 'src/elements/links/2023_Q4/LinkBranded';
import { LinkBrandedLargeStyles } from './LinkBrandedLarge.styles';

const LinkBrandedLarge = (props: LinkProps): JSX.Element => (
  <LinkBrandedLargeStyles
    standardSize='1.125'
    customFontWeight={700}
    customBorderRadius={36}
    colorScheme='Sunshine'
    {...props}
  />
);

export default LinkBrandedLarge;
